import { EmptyState, CriticalIcon } from '@buffer-mono/popcorn'

export const SavedReplyErrorState = (): JSX.Element => {
  return (
    <EmptyState variant="critical" role="alert" aria-live="polite">
      <EmptyState.Icon>
        <CriticalIcon />
      </EmptyState.Icon>
      <EmptyState.Heading>Failed to load saved replies</EmptyState.Heading>
      <EmptyState.Description>
        Something went wrong. Please try again later.
      </EmptyState.Description>
    </EmptyState>
  )
}
